import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/vacancy/page.tsx")